export const userRu = {
  user: {
    guest: 'Гость',
    menu: {
      title: 'Меню пользователя',
    },
    avatar: {
      alt: 'Аватар пользователя',
      guestAlt: 'Аватар гостя',
    },
    profile: {
      title: 'Профиль',
      edit_button: 'Редактировать профиль',
      subtitle: 'Ваша публичная информация и детали учётной записи.',
      user_id_label: 'ID пользователя',
      no_profile: 'Данные профиля недоступны',
      auth_required_title: 'Требуется аутентификация',
      auth_required_message: 'Войдите, чтобы использовать все функции приложения',
      login_button: 'Войти',
      register_button: 'Зарегистрироваться',
    },
    edit: {
      title: 'Редактировать профиль',
      subtitle: 'Обновите ваше имя, email и аватар.',
      name_label: 'Имя',
      name_placeholder: 'Введите ваше имя',
      name_required: 'Имя обязательно',
      email_label: 'Email',
      email_placeholder: 'Введите ваш email',
      email_invalid: 'Неверный адрес email',
      avatar_label: 'URL аватара',
      avatar_placeholder: 'https://www.gravatar.com/avatar/...',
      avatar_invalid: 'URL аватара должен быть от разрешённого провайдера (например, Gravatar)',
      avatar_help: 'Разрешены только URL от доверенных провайдеров, таких как Gravatar',
      generate_gravatar: 'Сгенерировать URL Gravatar из email',
      email_required_for_gravatar: 'Email требуется для генерации URL Gravatar',
      gravatar_generated: 'URL Gravatar сгенерирован',
      gravatar_generation_failed: 'Не удалось сгенерировать URL Gravatar',
      cancel: 'Отмена',
      save_changes: 'Сохранить изменения',
      show_public_profile: 'Показать публичный профиль',
    },
    publicProfile: {
      not_found: 'Профиль пользователя не найден',
      not_public: 'Этот профиль пользователя не является публичным',
      error: 'Не удалось загрузить профиль пользователя',
      error_title: 'Профиль недоступен',
      public_containers: 'Публичные контейнеры',
      no_containers: 'Нет публичных контейнеров',
      no_containers_description: 'Этот пользователь ещё не поделился публичными контейнерами',
    },
    roles: {
      admin: 'Администратор',
      owner: 'Владелец',
      premium: 'Премиум',
    },
  },
}
